import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import ScrollToTop from "../../components/feature/ScrollToTop";

export default function PoliticaCookies() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vpb-barcelona.com';

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Política de Cookies - Vaciado de Pisos Barcelona VPB",
    "description": "Política de cookies de Vaciado de Pisos Barcelona. Información sobre el uso de cookies, tipos de cookies utilizadas y cómo gestionarlas en su navegador.",
    "url": `${siteUrl}/politica-cookies`,
    "inLanguage": "es-ES",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Vaciado de Pisos Barcelona VPB",
      "url": siteUrl
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": siteUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Política de Cookies",
        "item": `${siteUrl}/politica-cookies`
      }
    ]
  };

  return (
    <>
      <title>Política de Cookies - Vaciado de Pisos Barcelona VPB</title>
      <meta name="description" content="Política de cookies de Vaciado de Pisos Barcelona. Información sobre el uso de cookies, tipos de cookies utilizadas y cómo gestionarlas en su navegador." />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={`${siteUrl}/politica-cookies`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <div className="min-h-screen bg-white">
        <Navbar />
        <ScrollToTop />
        
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de cookies</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">¿Qué son las cookies?</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
                Estas cookies nos ayudan a mejorar su experiencia de navegación, recordar sus preferencias y analizar cómo 
                utiliza nuestro sitio web. Para más información sobre el tratamiento de datos, consulta nuestra <a href="/politica-privacidad" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">política de privacidad</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Tipos de cookies que utilizamos</h2>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Cookies necesarias</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Estas cookies son esenciales para el funcionamiento del sitio web y no pueden desactivarse. 
                Incluyen cookies que permiten recordar sus preferencias de cookies y mantener la seguridad del sitio.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Cookies analíticas</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Utilizamos cookies analíticas para entender cómo los visitantes interactúan con nuestro sitio web. 
                Esto nos ayuda a mejorar la funcionalidad y el contenido del sitio. Toda la información recopilada 
                es anónima y se utiliza únicamente con fines estadísticos.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Cookies de funcionalidad</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Estas cookies permiten que el sitio web recuerde las elecciones que hace (como su idioma o región) 
                y proporcionan características mejoradas y más personales.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Gestión de cookies</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Puede controlar y/o eliminar las cookies como desee. Puede eliminar todas las cookies que ya están 
                en su ordenador y puede configurar la mayoría de los navegadores para evitar que se coloquen. 
                Sin embargo, si hace esto, es posible que tenga que ajustar manualmente algunas preferencias cada 
                vez que visite un sitio y que algunos servicios y funcionalidades no funcionen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                Para gestionar las cookies en su navegador, consulte la documentación de ayuda de su navegador específico:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                <li>Google Chrome</li>
                <li>Mozilla Firefox</li>
                <li>Safari</li>
                <li>Microsoft Edge</li>
                <li>Opera</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies de terceros</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                En algunos casos especiales, también utilizamos cookies proporcionadas por terceros de confianza. 
                Estas cookies de terceros nos ayudan a analizar y comprender cómo utiliza este sitio web. Para conocer más sobre nuestras prácticas de privacidad, revisa nuestro <a href="/aviso-legal" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">aviso legal</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Actualización de esta política</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Podemos actualizar esta política de cookies periódicamente para reflejar cambios en las cookies 
                que utilizamos o por otras razones operativas, legales o reglamentarias. Le recomendamos que 
                revise esta página regularmente para estar informado sobre nuestro uso de cookies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contacto</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Si tiene alguna pregunta sobre nuestra política de cookies, puede contactarnos en:
              </p>
              <p className="text-gray-600 leading-relaxed">
                <strong>Email:</strong> info@vaciadopisosbarcelona.com.es<br />
                <strong>Teléfono:</strong> 629 501 941
              </p>
            </section>

            <div className="mt-12 p-6 bg-gray-50 rounded-xl">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">¿Necesitas ayuda?</h3>
              <p className="text-gray-600 mb-4">
                Si tienes dudas sobre cookies o quieres conocer nuestros <a href="/#servicios" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">servicios de vaciado de pisos en Barcelona</a>, no dudes en <a href="/#contacto" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">contactarnos</a>.
              </p>
            </div>

            <p className="text-sm text-gray-500 mt-8">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}